import breakpoint from '@carvana/helios-layout/breakpoint';
import { background } from '@carvana/helios-styles';
import styled from 'styled-components';

export const Container = styled.main`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
  background-color: ${background.default};
`;

export const Body = styled.div`
  padding: 0 24px;
  min-width: 327px;
  background-color: ${background.default};
  margin: 0 auto;

  ${breakpoint.sm`
    padding: 0 32px;
  `}

  ${breakpoint.xl`
    max-width: 1272px;
    padding-top: 70px;
  `}
`;
